<template>
  <div
    class="segmented-toggle"
    role="radiogroup"
    :aria-label="ariaLabel"
  >
    <button
      v-for="option in options"
      :key="option.value"
      type="button"
      class="segmented-toggle-option text-body-2"
      :class="{ selected: modelValue === option.value }"
      role="radio"
      :aria-checked="modelValue === option.value"
      @click="handleSelect(option.value)"
    >
      {{ option.label }}
    </button>
  </div>
</template>

<script setup>
const props = defineProps({
  modelValue: {
    type: String,
    required: true,
  },
  options: {
    type: Array,
    required: true,
  },
  ariaLabel: {
    type: String,
    default: '',
  },
});

const emit = defineEmits(['update:modelValue']);

const handleSelect = (value) => {
  if (value === props.modelValue) {
    return;
  }

  emit('update:modelValue', value);
};
</script>

<style scoped lang="less">
.segmented-toggle {
  gap: 2px;
  padding: 2px;
  border: 1px solid @stroke-default;
  border-radius: 10px;
  background: @white;
}

.segmented-toggle-option {
  padding: 4px 12px;
  min-width: 71px;
  border-radius: 8px;
  background: transparent;
  color: @text-dark;
  cursor: pointer;

  &.selected {
    background: @text-darkest;
    color: @white;
  }
}
</style>
